import React from 'react';
import { CheckCircle, X } from 'lucide-react';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ 
  isOpen, 
  onClose, 
  title = 'Booking Confirmed!',
  message = 'Your reservation has been successfully submitted. We will contact you shortly to confirm your booking.'
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black bg-opacity-75" onClick={onClose}></div>
      
      <div className="relative bg-gray-900 border-2 border-primary-gold rounded-lg p-8 max-w-md w-full shadow-2xl">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="text-center">
          <div className="mb-4 flex justify-center">
            <CheckCircle className="w-16 h-16 text-primary-gold" />
          </div>
          
          <h2 className="text-2xl font-bold text-primary-gold mb-4 font-display">
            {title}
          </h2>
          
          <p className="text-gray-300 mb-6">
            {message}
          </p>

          <button
            onClick={onClose}
            className="bg-primary-gold text-primary-black px-8 py-3 rounded-full font-semibold hover:bg-primary-black hover:text-primary-gold hover:border-2 hover:border-primary-gold transition-all"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
